import { render } from "./TablaCriptomonedas.vue?vue&type=template&id=8bda2422&scoped=true"
import script from "./TablaCriptomonedas.vue?vue&type=script&lang=js"
export * from "./TablaCriptomonedas.vue?vue&type=script&lang=js"

import "./TablaCriptomonedas.vue?vue&type=style&index=0&id=8bda2422&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bda2422"]])

export default __exports__